module.exports = __webpack_public_path__ + "01_very_short_yellow.71fdbfe6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/01_very_short_yellow.png
// module id = aADM
// module chunks = 0